import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router';
import {PRODUCTS_ROUTE} from '../../../util/constants';
import {onSetCrumbs} from '../../../util/events';
import ProductsMoved from './productsMoved';

export default function ProductsMovedController() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    function onClickGoToProducts() {
        navigate(`${PRODUCTS_ROUTE}${location.search}`);
    }

    useEffect(() => {
        onSetCrumbs([
            {label: t('settings.vat.crumbSettings', 'Instellingen')},
            {label: t('settings.vat.crumbProducts', 'Producten & BTW')}
        ]);
    }, []);

    return <ProductsMoved onClickGoToProducts={onClickGoToProducts} />;
}
